/** Push conversion and engagement events for GTM / GA4 dataLayer. */
export function trackEvent(name, detail = {}) {
    if (typeof window === "undefined") {
        return;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: name,
        ...detail
    });
}
